import type { ILinkCard } from "./LinkCards.types";
import NavigationTile from "../NavigationTile/NavigationTile";
import { Link } from "react-router-dom";
import { useMemo } from "react";

import styles from "../NavigationTile/NavigationTile.module.scss";

interface Props extends ILinkCard {
  pathPrefix?: string | Array<string | undefined>;
}

const LinkCard = ({ pathPrefix, path, name, desc, onClick }: Props) => {
  const preparedPath = useMemo(() => {
    let parsedPath = "/";
    if (pathPrefix) {
      if (typeof pathPrefix === "string") {
        parsedPath += pathPrefix + "/";
      } else if (Array.isArray(pathPrefix)) {
        for (const part of pathPrefix) {
          if (part) parsedPath += part + "/";
        }
      }
    }
    if (path === "desktop-app") {
      parsedPath += "desktop-and-tablet-apps";
    } else {
      parsedPath += path;
    }
    return parsedPath;
  }, [path, pathPrefix]);

  const displayName = name.match(/Desktop App/i)
    ? "Desktop / Tablet App"
    : name;

  const tile = (
    <NavigationTile
      title={displayName}
      description={desc}
      onClick={onClick}
    />
  );

  return path ? (
    <Link
      key={preparedPath}
      to={preparedPath}
      className={styles.link}>
      {tile}
    </Link>
  ) : (
    tile
  );
};

export default LinkCard;
